export default class Range {

    constructor() {
        this.addEvents();
    }

    addEvents() {

        const inputSlider = document.querySelector(".rangeinput");
        let nova55Value = 0;
        let result = document.querySelector('.anual-profit span');

        if(inputSlider) {

            const slideValue = document.querySelector("span.show");
            const slideArrow = document.querySelector("div.arrows");
            const inputProgress = document.querySelector(".range__progress");
            if(slideValue) {
                inputSlider.oninput = (() => {
                    let value = inputSlider.value / 100;
                    nova55Value = inputSlider.value;
                    let valueText = inputSlider.value;
                    slideValue.textContent = this.numberWithSpaces(valueText);
                    slideValue.style.left = (value) + "%";
                    slideArrow.style.left = (value) + "%";
                    inputProgress.style.width = (value) + "%";
                    slideValue.classList.add("show");
                    updateResult();
                });
            }

            function updateResult() {
                if (nova55Value >= 50) {
                    result.innerHTML = "<span class='currency'>£</span>"+calc(nova55Value);
                } else {
                    result.innerHTML = "<span class='currency'>£</span>"+0;
                }
            }

            function calc(nova) {
                return (169 * nova).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        }
    }

    numberWithSpaces(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

}





